import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { getSoldNumbers } from "../../services/numberService";
import "./SoldNumbersCarousel.css";

const SoldNumbersCarousel = () => {
    const [soldNumbers, setSoldNumbers] = useState([]);
    const [loading, setLoading] = useState(true);

    const responsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
        tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
        mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
    };

    const networkClassMap = {
        Dialog: "dialog",
        Mobitel: "mobitel",
        Airtel: "airtel",
        Hutch: "hutch",
    };

    useEffect(() => {
        const fetchSoldNumbers = async () => {
            try {
                const data = await getSoldNumbers();
                // Map API data to carousel format
                const mappedData = data.map(item => ({
                    number: item.number,
                    network: item.network,
                    company: item.company
                }));
                setSoldNumbers(mappedData);
                setLoading(false);
            } catch (error) {
                console.error("Failed to fetch sold numbers:", error);
                setLoading(false);
            }
        };

        fetchSoldNumbers();
    }, []);

    if (loading) {
        return (
            <div className="container text-center py-5">
                <p>Loading sold numbers...</p>
            </div>
        );
    }

    if (soldNumbers.length === 0) {
        return (
            <div className="container text-center py-5">
                <p>No sold numbers available at the moment.</p>
            </div>
        );
    }

    return (
        <div className="container-fluid sold-carousal py-4">
            <div className="container text-center">
                <h2 className="section-title-sold fw-bold mb-2">Recently Sold Numbers</h2>
                <p className="section-tagline-sold">
                    Hurry Up..!!! Get your VIP number today!
                </p>
            </div>

            <Carousel
                responsive={responsive}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                showDots={false}
                removeArrowOnDeviceType={["mobile"]}
                containerClass="carousel-container"
                itemClass="px-2"
            >
                {soldNumbers.map((item, idx) => (
                    <div className="sold-card shadow-lg text-center" key={idx}>
                        <div className="sold-ribbon">SOLD OUT</div>
                        <h2 className="hotline-number">{item.number}</h2>
                        <span className={`network-tag ${networkClassMap[item.network] || ""}`}>
                            {item.network}
                        </span>
                        {/* <span className="network-tag">
                            {item.company}
                        </span> */}
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default SoldNumbersCarousel;
